var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 22.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 0H2.8A2.8 2.8 0 0 0 .014 2.8L0 19.6a2.81 2.81 0 0 0 2.8 2.8h22.4a2.81 2.81 0 0 0 2.8-2.8V2.8A2.81 2.81 0 0 0 25.2 0m0 5.6-11.2 7-11.2-7V2.8l11.2 7 11.2-7Z"
  })));
};
export default SvgEmail;